var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFashionStylinginline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M4 15v47M4 6v9m36 17.5V62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 6v22"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 13,
  r: 5,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "m33 22.5 4.882 4.533a3 3 0 0 0 4.162-.077l3.784-3.784A4 4 0 0 1 48.657 22h8.533c.81 0 1.888.779 1.99 1.801L62 42H44l2-12m4.902 32h4.196a2 2 0 0 0 1.997-1.9L58 42H48l.905 18.1a2 2 0 0 0 1.997 1.9zM4 11c9 0 10-4 18-4s9 4 18 4M4 15h12m8 0h16"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 2,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 4,
  r: 2,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 53h8.5m19 0H40"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M18.04 21c.278 1.696 1.945 3 3.96 3s3.682-1.304 3.96-3H28l.936 1.872a6 6 0 0 1 .38 4.407L27 35l-3.039.608a10 10 0 0 1-3.922 0L17 35l-2.316-7.72a6 6 0 0 1 .38-4.408L16 21zM27 36l6 23-3.845.699a40 40 0 0 1-14.31 0L11 59l6-23m7-21a2 2 0 1 0-4 0c0 1.105 2 2.5 2 4l-3 1.5m3-1.5 3 1.5"
}))));
export default SvgFashionStylinginline;